/* global BigInt */
import classes from './home.module.css';
import classes3 from './Click_frame.module.css';
import resets from './_resets.module.css';
import Brazil from './brazil.png';
import Usa from './usa.png';
import Tether from './tether.png';
import React, { useEffect, useState, useRef } from 'react';
import Web3 from 'web3';
import { Buffer } from "buffer/";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { ENDPOINT, BRLA_CONTRACT_ADDRESSES, USDT_CONTRACT_ADDRESSES, MANTEINENCETOKEN, USDC_CONTRACT_ADDRESSES, POLYGONURLC} from '../../variaveis';
import { BRLAContractAbi, USDTContractAbi, USDCContractAbi } from '../../utils/abis';
import { useNavigate } from "react-router-dom";
import TransferMobile from './TransferMobile';
import SwapMobile from './SwapMobile';
import DepositMobile from './DepositMobile';
import PaymentMobile from './PaymentMobile';
import axios from 'axios';

/* @figmaId 3:492 */

const API_BALANCE_URL = "https://api.brla.digital:5567/v1/business/balance";

function WalletMobile({ limit, showLink, showButton  }) {
  const [pixKeyType, setPixKeyType] = useState(null);
  const [pixKeyValid, setPixKeyValid] = useState(null);
    const [usdSpot, setUsdSpot] = useState(null);
  const [TokenRecebe, setTokenRecebe] = useState({
    flag: 'currency-flag-brl',
    abbreviation: 'BRL'
  });
    const [Token, setToken] = useState({
      flag: 'currency-flag-brl',
      abbreviation: 'BRL'
    });

  const handlePixKeyTypeChange = (value) => {
    setPixKeyType(value);
  };

  const handlePixKeyValidChange = (value) => {
    setPixKeyValid(value);

  };

  const handleTokenRecebeChange = (value) => {
    setTokenRecebe(value);
  };

  const handleTokenSelectChange = (value) => {
    setToken(value);
  };


    const [tooltip, setTooltip] = React.useState(null);
    const [showTransaction, setShowTransactions] = useState(false);
    const [transactionNumbers, setTransactionNumbers] = useState(4);
    const [isLoading, setIsLoading] = useState(true);
    const [pendingRequests, setPendingRequests] = useState(1);
    const [users, setUsers] = useState([]);
    const [balance, setBalance] = useState(0);
    const [balanceUsd, setBalanceUsd] = useState(0);
    const [balanceUsdt, setBalanceUsdt] = useState(0);
    const [wallets, setWallets] = useState([]);
    const [historyData, setHistoryData] = useState([]);
    const [kychistoryData, setKycHistoryData] = useState([]);
    const [showDeposit, setShowDeposit] = useState(false);
    const [showTransfer, setShowTransfer] = useState(false);
    const [showSwap, setShowSwap] = useState(false);
    const [showPayment, setShowPayment] = useState(false);
    const [showSettings, setShowsettings] = useState(false);
    const [showSecondMenu, setShowsecondMenu] = useState(false);
    const buttonRefDeposit = useRef(null);
    const buttonRefTransfer = useRef(null);
    const buttonRefSwap = useRef(null);
    const menuRef = useRef(null);
    const buttonRefMenu = useRef(null);

    function numberWithThousandSeparator(number) {
      return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function mapStatus(item, type) {
      if (!item) return "unknown";
    
      if (type === 'swap') {
        if (!item.smartContractOps) return "Pendente";
        if (item.smartContractOps[0]?.feedback?.success === true) return "Completo";
        if (item.smartContractOps[0]?.feedback?.success === false) return "Falha";
        return "Pendente";
      }
      if (type === 'payment') {
        if (item?.paymentOps?.[0]?.transfers?.[0]?.feedbacks?.[0]?.transferStatus === "success") return "Completo";
        if (item?.paymentOps?.[0].smartContractOps?.[0]?.feedback?.success === false) return "Falha";
        if (item?.paymentOps?.[0]?.transfers?.[0]?.feedbacks?.[0]?.transferStatus === false) return "Falha";
        return "Pendente";
    }
    
    
      if (type === 'buy') {
        if (item?.mintOps?.[0]?.smartContractOps?.[0]?.feedback?.success) return "Completo";
        if (item?.mintOps?.[0]?.smartContractOps?.[0]?.feedback?.success === false) return "Falha";
        if (item.status === "PAID") return "Pendente";
        if (item.status === "UNPAID") return "Pendente";
      } else if (type === 'sell') {
        if (item?.transfers?.[0]?.feedbacks?.[0]?.logType === "success") return "Completo";
        if (item?.smartContractOps?.[0]?.feedback?.success === false) return "Falha";
        return "Pendente"
      }
      if (type==='onchain-deposit') {
        return "Completo"
      }
    
      if (type==='onchain-out') {
        if (item?.smartContractOps?.[0]?.feedback?.success === true) return "Completo";
        if (item?.smartContractOps?.[0]?.feedback?.success === false) return "Falha";
        return "Pendente";
      }
    
    
      else return "Pendente"
      
    }

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (showSecondMenu && menuRef.current && !menuRef.current.contains(event.target) && !buttonRefMenu.current.contains(event.target)) {
          setShowsecondMenu(false);
          
        }
      };
    
      document.addEventListener('click', handleClickOutside);
    
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }, [showSecondMenu]);

    const toggleMenu = () => {
      setShowsecondMenu(!showSecondMenu);
    };
    
    useEffect(() => {
      // Obtem os usuários do localStorage
      const loadedUsers = localStorage.getItem('userData');
      if (loadedUsers) {
        setUsers(JSON.parse(loadedUsers));
      }
  
  
      // Obtem os dados do histórico do localStorage
      const loadedHistoryData = localStorage.getItem('historyData');
      if (loadedHistoryData) {
        let historyData = JSON.parse(loadedHistoryData);
      
        // Ordenando os dados do histórico pela data de atualização
        historyData = historyData.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      
        // Criando um objeto onde a chave é o ID e o valor é o item do histórico
        setHistoryData(historyData);
      };
  
  
      const loadedKYCHistory = localStorage.getItem('kychistory');
      if (loadedKYCHistory) {
        const KycHistory = JSON.parse(loadedKYCHistory);
        console.log("VAI: ", KycHistory)
        // Criando um objeto onde a chave é o ID e o valor é o item do histórico
        setKycHistoryData(KycHistory);
  
  
      };
  
      const fetchBalance = async () => {
    
   
        // Cria uma nova instância do web3 com o Infura
        const web3 = new Web3(new Web3.providers.HttpProvider(POLYGONURLC));
  
        // Mapeia cada carteira para um objeto que inclui o saldo BRLA
        
            const BRLA_CONTRACT_ADDRESS = BRLA_CONTRACT_ADDRESSES[80001];
            const USDC_CONTRACT_ADDRESS = USDC_CONTRACT_ADDRESSES[80001];
            const USDT_CONTRACT_ADDRESS = USDT_CONTRACT_ADDRESSES[80001];
            const contract = new web3.eth.Contract(BRLAContractAbi, BRLA_CONTRACT_ADDRESS);
            const contractUsd = new web3.eth.Contract(USDCContractAbi, USDC_CONTRACT_ADDRESS);
            const contractUsdt = new web3.eth.Contract(USDTContractAbi, USDT_CONTRACT_ADDRESS);
            const balance = await contract.methods.balanceOf(users?.wallets?.evm).call();
            const balanceUsd = await contractUsd.methods.balanceOf(users?.wallets?.evm).call();
            const balanceUsdt = await contractUsdt.methods.balanceOf(users?.wallets?.evm).call();
           
        
        
  
        
    };
  
    if (users?.wallets?.evm) {
      fetchBalance();
    }
    setPendingRequests(0);
  
    }, [users?.wallets?.evm]);


    useEffect(() => {
      const fetchBalances = async () => {
        try {
          const response = await axios.get(API_BALANCE_URL, {
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
           
            }
          });
          const balances = response.data.balances;
          
          setBalance(parseFloat(balances.find(token => token.tokenName === "BRLA")?.amount || 0));
          setBalanceUsd(parseFloat(balances.find(token => token.tokenName.includes("USDC"))?.amount || 0));
          setBalanceUsdt(parseFloat(balances.find(token => token.tokenName === "USDT")?.amount || 0));
        } catch (error) {
          setBalance(0);
          setBalanceUsd(0);
          setBalanceUsdt(0);
          console.error("Error fetching balance data:", error);
          if (error.response?.status === 401) {
            navigate('/login');
          }
        } finally {
          setIsLoading(false);
        }
      };
  
      fetchBalances();
    }, []);


    useEffect(() => {
      const loadData = async () => {
        const lastRequestDate = localStorage.getItem('lastRequestDate');
        const currentDate = new Date();
  
        
  
  
    
        if (lastRequestDate && currentDate - new Date(lastRequestDate) < 3000) {
          // If less than a minute has passed since the last request, do not make a new request
           // Obtem os usuários do localStorage
      const loadedUsers = localStorage.getItem('userData');
      if (loadedUsers) {
        setUsers(JSON.parse(loadedUsers));
      }
  
  
      // Obtem os dados do histórico do localStorage
      const loadedHistoryData = localStorage.getItem('historyData');
      if (loadedHistoryData) {
        let historyData = JSON.parse(loadedHistoryData);
      
        // Ordenando os dados do histórico pela data de atualização
        historyData = historyData.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      
        // Criando um objeto onde a chave é o ID e o valor é o item do histórico
        setHistoryData(historyData);
      
      };
  
  
      const loadedKYCHistory = localStorage.getItem('kychistory');
      if (loadedKYCHistory) {
        const KycHistory = JSON.parse(loadedKYCHistory);
        console.log("VAI: ", KycHistory)
        // Criando um objeto onde a chave é o ID e o valor é o item do histórico
        setKycHistoryData(KycHistory);
  
  
      };
  
        }
  
        else {
    
    
        const resPurchases = await fetch(`${ENDPOINT}/pay-in/pix/history?page=1&pageSize=100`, {
          method: 'GET',
          credentials: 'include',
        });
        const resSales = await fetch(`${ENDPOINT}/pay-out/history?page=1&pageSize=100`, {
          method: 'GET',
          credentials: 'include',
        });
  
        if (resSales.status === 401) {
          navigate('/login');
          return;
        }
    
    
        const resOncahinDeposit = await fetch(`${ENDPOINT}/on-chain/history/in`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            "MAINTENANCE-TOKEN":MANTEINENCETOKEN
          },
        });
  
        
        const resSwaps = await fetch(`${ENDPOINT}/swap/history`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            "MAINTENANCE-TOKEN":MANTEINENCETOKEN
          },
        });
      
        const resPayments = await fetch(`${ENDPOINT}/payment/history`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            "MAINTENANCE-TOKEN":MANTEINENCETOKEN
          },
        });
  
        const resOnchainOut = await fetch(`${ENDPOINT}/on-chain/history/out`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            "MAINTENANCE-TOKEN":MANTEINENCETOKEN
          },
        });
      
        const bodySwaps = await resSwaps.json();
        const bodyPayments = await resPayments.json();
      const swaps = bodySwaps.swapLogs || [];
      const payments = bodyPayments.paymentLogs || [];
  
        const bodyOnchainDeposit = await resOncahinDeposit.json();
        const bodyPurchases = await resPurchases.json();
        const bodySales = await resSales.json();
        const bodyOnchainOut = await resOnchainOut.json();
        const purchases = bodyPurchases.depositsLogs || [];
        const sales = bodySales.transfersLogs || [];
  
        const formatTaxId = (taxId) => {
          if (taxId && typeof taxId === 'string') {
            taxId = taxId.replace(/\D/g, ''); // Remover caracteres não numéricos, se houver
        
            if (taxId?.length === 11) {
              return '***.' + taxId.slice(0, 3) + '.' + taxId.slice(3, 6)  + '-**'; // CPF
            } else if (taxId?.length === 14) {
              return '**.' + taxId.slice(0, 3) + '.' + taxId.slice(3, 6) +   '/****-'  ; // CNPJ
            } else if (taxId?.length === 6) {
              return '***.' + taxId.slice(0, 3) + '.' + taxId.slice(3, 6) + '-**'; // Seis números
            }
          }
        
          return '';
        };
        
        
        
        const depositsLogsWithType = bodyPurchases.depositsLogs.map(item => ({
          id: item.mintOps?.[0]?.smartContractOps?.[0].tx || 'pending payment',
          chain: item.chain,
          walletAddress: item.walletAddress,
          amount: numberWithThousandSeparator((item.amount-item.mintOps?.[0]?.fee)/100),
          status: mapStatus(item, 'buy'),
          type: 'buy',
          updatedAt: item.mintOps?.[0]?.smartContractOps?.[0]?.feedback?.[0]?.createdAt || item.mintOps?.[0]?.smartContractOps?.[0]?.createdAt || item.mintOps?.[0]?.createdAt || item.createdAt,
          taxId: formatTaxId(item.taxId),
          failedReason: item.mintOps?.[0]?.smartContractOps?.[0]?.notPostedReason?.[0] || item.mintOps?.[0]?.smartContractOps?.[0]?.feedback?.[0]?.errorMsg?.[0],
          name: item.payerName,
          fee: item.mintOps?.[0]?.fee/100
          
        }));
       
        
        const transfersLogsWithTypeAndRenamed = bodySales.transfersLogs.map(item => ({
          id: item.smartContractOps?.[0]?.tx || 'pending burn',
          chain: item.chain,
          walletAddress: item.walletAddress,
          amount: `(${numberWithThousandSeparator(item.amount/100)})`,
          type: 'sell',
          status: mapStatus(item, 'sell'),
          updatedAt: item.transfers?.[0]?.feedbacks?.[0]?.createdAt || item.transfers?.[0]?.createdAt || item.smartContractOps?.[0]?.feedback?.createdAt || item.smartContractOps?.[0]?.createdAt || item.createdAt,
          taxId:  formatTaxId(item.transfers?.[0]?.taxId),
          failedReason: item.smartContractOps?.[0]?.notPostedReason || item.smartContractOps?.[0]?.feedback?.errorMsg || 'A transação falhou',
          name: item.transfers?.[0]?.name,
          fee:item.fee/100
        }));
  
        const PaymentsLogsWithTypeAndRenamed = payments.map(item => ({
          id: item.smartContractOps?.[0]?.tx || 'pending payment',
          chain: item.chain,
          walletAddress: item.address,
          amount: `(${numberWithThousandSeparator(item.usdAmount/100)})`,
          type: 'payment',
          status: mapStatus(item, 'payment'),
          updatedAt: item.paymentOps?.[0]?.smartContractOps?.[0]?.feedback?.createdAt || item.paymentOps?.[0]?.smartContractOps?.[0]?.createdAt || item.paymentOps?.[0].createdAt || item.createdAt, 
          coin: item.coin,
          brlaAmount: item.brlaAmount,
          usdAmount: item.usdAmount,
          basePrice: item.basePrice,
          baseFee: item.baseFee,
          gassFee: 0,
          failedReason: item.paymentOps?.[0]?.smartContractOps?.[0]?.notPostedReason?.[0] || item.paymentOps?.[0]?.smartContractOps?.[0]?.feedback?.errorMsg,
          name: item.paymentOps?.[0].transfers?.[0].name || 'Pendente',
          taxId:  formatTaxId(item.paymentOps?.[0].transfers?.[0].taxId),
          fee: item.baseFee
        
        }));
  
        const OnchainDepositLogsWithTypeAndRenamed = bodyOnchainDeposit.onchainLogs.map(item => ({
          id: item.id,
          chain: item.chain,
          tokenAddress: item.tokenAddress,
          fromAddress: item.fromAddress,
          toAddress: item.toAddress,
          tx: item.tx,
          amount: `(${numberWithThousandSeparator(item.amount)})`,
          amountclean: parseFloat(item.amount).toFixed(2),
          type: 'onchain-deposit',
          status: mapStatus(item, 'onchain-deposit'),
          updatedAt: item.createdAt, 
          coin: item.tokenAddress === '0xc2132D05D31c914a87C6611C10748AEb04B58e8F' ? 'USDT'  : item.tokenAddress ===  '0xE6A537a407488807F0bbeb0038B79004f19DDDFb' ? 'BRLA' :  item.tokenAddress ===  '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174' ? 'USDC' : 'TOKEN',
          fee:0 
        
        }));  
  
        const calculateValue = (coin, value) => {
          if (coin === 'USDT' || coin === 'USDC') {
              return value / 1000000;
          } else if (coin === 'BRLA') {
              const bigIntValue = BigInt(value) / 1000000000000000000n;
              return Number(bigIntValue); // Convertendo BigInt para Number
          } else {
              return value;
          }
        };
        
        
        const OnchainOutLogsWithTypeAndRenamed = bodyOnchainOut.onchainLogs.map(item => {
          const calculatedValue = calculateValue(item.outputCoin, item.value);
        
          return {
              id: item.id,
              userId: item.userId,
              chain: item.chain,
              fromAddress: item.from,
              toAddress: item.to,
              tx: item.smartContractOps?.[0]?.tx,
              amount: `(${numberWithThousandSeparator(calculatedValue)})`,
              amountclean: parseFloat(calculatedValue).toFixed(2),
              type: 'onchain-out',
              status: mapStatus(item, 'onchain-out'),
              updatedAt: item.createdAt,
              coin: item.outputCoin,
              fee:0  
          };
        });
  
      
            // Mapear os dados
      const swapsLogsWithTypeAndRenamed = swaps.map(item => ({
        id: item.smartContractOps?.[0]?.tx || 'pending swap',
        chain: item.chain,
        walletAddress: item.walletAddress,
        amount: item.usdToBrla ? numberWithThousandSeparator(item.brlaAmount/100) : `(${numberWithThousandSeparator(item.usdAmount/100)})`,
        type: 'swap',
        status: mapStatus(item, 'swap'),
        updatedAt: item.smartContractOps?.[0]?.feedback?.createdAt || item.smartContractOps?.[0]?.createdAt || item.createdAt, 
        coin: item.coin,
        brlaAmount: item.brlaAmount,
        usdAmount: item.usdAmount,
        usdToBrla: item.usdToBrla,
        basePrice: item.basePrice,
        baseFee: item.baseFee,
        gassFee: 0,
        failedReason: item.smartContractOps?.[0]?.notPostedReason?.[0] || item.smartContractOps?.[0]?.feedback?.errorMsg,
        name: `${item.walletAddress.slice(0, 3)}....${item.walletAddress.slice(-3)}`,
        walletAddress: item.walletAddress,
        receiverAddress: item.receiverAddress,
        usdToBrla: item.usdToBrla
  
      }));
  
      const swapLogTxValues = swaps.map(log => 
        log.smartContractOps && log.smartContractOps.length > 0 ? log.smartContractOps[0].tx : null
      ).filter(tx => tx !== null);
      
      const paymentsLogTxValues = payments.map(log => 
        log.paymentOps?.[0]?.smartContractOps?.[0]?.tx 
      ).filter(tx => tx !== null);
  
      const depositLogTxValues = purchases.map(log => 
        log.mintOps?.[0]?.smartContractOps?.[0]?.tx 
      ).filter(tx => tx !== null);
      
      
      const filteredOnchainDepositLogs = OnchainDepositLogsWithTypeAndRenamed.filter(item => 
        !swapLogTxValues.includes(item.tx) && !paymentsLogTxValues.includes(item.tx) && !depositLogTxValues.includes(item.tx) 
      );
      
      
      
      
     
      
      const filteredOnchainOut = OnchainOutLogsWithTypeAndRenamed.filter(item => 
        !swapLogTxValues.includes(item.tx) && !paymentsLogTxValues.includes(item.tx)
      );
      
      
      
            
      const historyData = [...depositsLogsWithType, ...transfersLogsWithTypeAndRenamed, ...swapsLogsWithTypeAndRenamed, ...PaymentsLogsWithTypeAndRenamed, ...filteredOnchainDepositLogs, ...filteredOnchainOut];
      
        localStorage.setItem('nextRequestDate', currentDate.toISOString());
        localStorage.setItem('historyData', JSON.stringify(historyData));
    
        // After making the requests, store the current date as the last request date
        localStorage.setItem('lastRequestDate', currentDate.toISOString());
        setKycHistoryData(historyData)
  
            // Obtem os usuários do localStorage
      const loadedUsers = localStorage.getItem('userData');
      if (loadedUsers) {
        setUsers(JSON.parse(loadedUsers));
      }
  
  
      // Obtem os dados do histórico do localStorage
      const loadedHistoryData = localStorage.getItem('historyData');
      if (loadedHistoryData) {
        let historyData = JSON.parse(loadedHistoryData);
      
        // Ordenando os dados do histórico pela data de atualização
        historyData = historyData.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      
        // Criando um objeto onde a chave é o ID e o valor é o item do histórico
        setHistoryData(historyData);
        console.log("vamos ver: ", historyData)
      };
  
  
      const loadedKYCHistory = localStorage.getItem('kychistory');
      if (loadedKYCHistory) {
        const KycHistory = JSON.parse(loadedKYCHistory);
        console.log("VAI: ", KycHistory)
        // Criando um objeto onde a chave é o ID e o valor é o item do histórico
        setKycHistoryData(KycHistory);
  
  
      };
  
    }};
    
      loadData();
    }, []);
    
  
    
  
  
  
  
  

    
    
    
    const navigate = useNavigate();
    
     
  
        useEffect(() => {
     
      }, []);
      const depositRef = useRef();
      const transferRef = useRef();
      const swapRef = useRef();
  
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (showDeposit && depositRef.current && !depositRef.current.contains(event.target) && !buttonRefDeposit.current.contains(event.target)) {
            setShowDeposit(false);
          }
        };
      
        document.addEventListener('click', handleClickOutside);
      
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
      }, [showDeposit]);

      useEffect(() => {
        console.log("vai pix type", pixKeyType)
      }, [pixKeyType]);

      useEffect(() => {
        console.log("vai pix valid", pixKeyValid)
      }, [pixKeyValid]);
      
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (showTransfer && transferRef.current && !transferRef.current.contains(event.target) && !buttonRefTransfer.current.contains(event.target)) {
            setShowTransfer(false);
            console.log("VAI")
          }
        };
      
        document.addEventListener('click', handleClickOutside);
      
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
      }, [showTransfer]);
  
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (showSwap && swapRef.current && !swapRef.current.contains(event.target) && !buttonRefSwap.current.contains(event.target)) {
            setShowSwap(false);
           
          }
        };
      
        document.addEventListener('click', handleClickOutside);
      
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
      }, [showSwap]);
      
  
      useEffect(() => {
        // Fetch the usd_spot and usdt_spread from the API
        const fetchExchangeRate = async () => {
          try {
            const response = await axios.get('https://api.betgenius.digital:4567/usdt');
            const { usd_spot } = response.data;
            setUsdSpot(parseFloat(usd_spot)); // Ensure usd_spot is a number
          } catch (error) {
            console.error("Error fetching exchange rate:", error);
          }
        };
    
        fetchExchangeRate();
      }, []);

      
      useEffect(() => {
        // Se não há requisições pendentes, então as requisições maamacabaram
        if (pendingRequests === 0) {
          // Adiciona um delay de 0.2 segundos antes de remover o estado de carregamento
          setIsLoading(false);
        } 
      }, [pendingRequests]);
  
      if (isLoading) {
        // Retorne um spinner de loading, um placeholder ou null
        return <div></div>;
      }
  
  
  
  
  
  
  
  
  
  

  
  
      function formatDate(dateString) {
        // Extrai os componentes da data da string
        const [year, month, day] = dateString.slice(0, 10).split('-');
      
        // Mapeia os números dos meses para os nomes dos meses
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const monthName = monthNames[parseInt(month, 10) - 1];
      
        // Retorna a data formatada
        return `${monthName} ${day}, ${year}`;
      }

      function getStatusColor(status) {
        switch (status) {
          case 'Pendente':
            return '#ecc434';
          case 'Completo':
            return '#00dc84';
          case 'Falha':
            return '#ff0000'; // substitua por sua cor vermelha preferida
          default:
            return '#000000'; // cor padrão para status desconhecidos
        }
      }

      function formatAmount(amount) {
        const isPositive = !amount.includes("(");
        const color = isPositive ? '#00dc84' : '#ff0000'; // substitua por suas cores preferidas
        const sign = isPositive ? '+' : '-';
        const absoluteAmount = amount.replace(/[()]/g, ''); // remove os parênteses
        return (
          <span style={{ color: color}}> {sign}{absoluteAmount} BRL  </span>
        );
      }


      function clicktransactions() {
        setShowTransactions(!showTransaction);
        setShowDeposit(false);
        setShowTransfer(false);
        setShowSwap(false);
        setShowsettings(false);
        setShowPayment(false);

        if (transactionNumbers===4) {
            setTransactionNumbers(8)
        } 
        
        else {
            setTransactionNumbers(4)
        }
      }

      function clickHome() {
        setShowTransactions(false);
        setShowDeposit(false);
        setShowTransfer(false);
        setShowSwap(false);
        setShowsettings(false);
        setShowPayment(false);
        setTransactionNumbers(4);
      }

      function clickTransfer() {
        setShowTransactions(false);
        setShowDeposit(false);
        setShowTransfer(!showTransfer);
        setShowSwap(false);
        setShowsettings(false);
        setShowPayment(false);
        setTransactionNumbers(4);
      }

      function clickSwap() {
        setShowTransactions(false);
        setShowDeposit(false);
        setShowTransfer(false);
        setShowSwap(!showSwap);
        setShowsettings(false);
        setShowPayment(false);
        setTransactionNumbers(4);
      }

      function clickDeposit() {
        setShowTransactions(false);
        setShowDeposit(!showDeposit);
        setShowTransfer(false);
        setShowSwap(false);
        setShowsettings(false);
        setShowPayment(false);
        setTransactionNumbers(4);
      }

      function clickPayment() {
        setShowTransactions(false);
        setShowDeposit(false);
        setShowTransfer(false);
        setShowSwap(false);
        setShowsettings(false);
        setShowPayment(!showPayment);
        setTransactionNumbers(4);
      }

      function clickSettings() {
        setShowTransactions(false);
        setShowDeposit(false);
        setShowTransfer(false);
        setShowSwap(false);
        setShowsettings(!showSettings);
        setShowPayment(false);
        setTransactionNumbers(4);
      }
     
  return (
    <div className={`${resets.storybrainResets} ${( ( TokenRecebe.abbreviation==='USDT' || TokenRecebe.abbreviation==='USDC')   && Token.abbreviation==='BRL') ? classes.root3 : ( TokenRecebe.abbreviation==='BRLA' && Token.abbreviation==='BRL') ? classes.root :  ( TokenRecebe.abbreviation==='BRLA' && Token.abbreviation==='USD') ? classes.root4 :  ( TokenRecebe.abbreviation==='BRL' && (Token.abbreviation==='USD' || Token.abbreviation==='USDT' ) && !pixKeyValid) ? classes.root4 : ( TokenRecebe.abbreviation==='BRL' && Token.abbreviation==='USD' && (pixKeyType==='CPF' || pixKeyType==='CNPJ' )) ? classes.root5 : (  (Token.abbreviation==='USD' || Token.abbreviation==='USDT') && pixKeyValid) ? classes.root6 :  (pixKeyType !== 'CPF' && pixKeyType !== 'CNPJ'   && pixKeyValid && Token.abbreviation==='BRL' && TokenRecebe.abbreviation==='BRL') ? classes.root2 : ( pixKeyValid) ? classes.root1 : classes.root}`}>
      <div className={classes.rectangle1}></div>
      <div className={classes.rectangle2}></div>
      <div className={classes.body_frame}>

{ !showTransaction  && !showSwap && !showDeposit && !showTransfer && !showSettings  && !showPayment ?
        <div className={classes.link}>
          <div className={classes.divH2d60786a2a}>
            <div className={classes.divTwAvatar}>
              <div className={classes.divTwAvatar__content}>
                <div className={classes.divCurrencyFlag}></div>
              </div>
              <img src={Brazil}/>
            </div>
          </div>
          <div className={classes.divBalanceCard_balanceCardText}>
            <div className={classes.heading25698}>R$ {
  isNaN(balance) 
    ? "Loading..." 
    : `${(Math.floor(parseFloat(balance) * 100) / 100).toFixed(2)}`
}</div>
            <div className={classes.divNpTextBodyDefault}>
              <div style={{marginTop:'5px'}} className={classes.realBrasileiro}>Real brasileiro</div>
            </div>
          </div>
        </div> : <div></div>}

        { !showTransaction && !showTransfer && !showSwap && !showDeposit && !showSettings && !showPayment ? 


        <div className={classes.link2}>
          <div className={classes.divH2d60786a2a2}>
            <div className={classes.divTwAvatar2}>
                <img src='https://brla.digital/static/media/usdc.png'/>         
            </div>
          </div>
          <div className={classes.divBalanceCard_balanceCardText2}>
            <div className={classes.heading256982}>U$  {
  isNaN(balanceUsd) 
    ? "Loading..." 
    : `${(Math.floor(parseFloat(balanceUsd) * 100) / 100).toFixed(2)}`
}</div>
            <div className={classes.divNpTextBodyDefault2}>
              <div style={{marginTop:'5px'}} className={classes.dolarAmericano}>USD Circle</div>
            </div>
          </div>
        </div> : <div></div>}

        
        { !showTransaction && !showTransfer && !showSwap && !showDeposit && !showSettings && !users?.autoConvert && !showPayment ? 


<div className={classes.link2}>
  <div className={classes.divH2d60786a2a2}>
    <div className={classes.divTwAvatar2}>
        <img src={Tether}/>         
    </div>
  </div>
  <div className={classes.divBalanceCard_balanceCardText2}>
    <div className={classes.heading256982}>U$  {
  isNaN(balanceUsdt) 
    ? "Loading..." 
    : `${(Math.floor(parseFloat(balanceUsdt) * 100) / 100).toFixed(2)}`
}</div>
    <div className={classes.divNpTextBodyDefault2}>
      <div style={{marginTop:'5px'}} className={classes.dolarAmericano}>Dólar Tether</div>
    </div>
  </div>
</div> : <div></div>}

        {!showTransfer && !showSwap  && !showDeposit && !showSettings && !showPayment ?
        
        <div className={classes.link3}>
          <div className={classes.divBalanceCard_balanceCardText3}>
            <div className={classes.heading256983}>Transações Recentes</div>
          </div>
          <table style={{border:'none', background:'#f5f5f8', display:'block'}}>
     
    
          <thead data-testid="header">
            <tr>
              <th style={{background:'#f5f5f8', border:"none", width:'70px', fontSize:'14px'}} className={classes.tipo} colSpan={1}>Tipo</th>
              <th style={{background:'#f5f5f8', border:"none", width:'120px', fontSize:'14px'}} className={classes.data} colSpan={1}>Data</th>
              <th style={{background:'#f5f5f8', border:"none", width:'100px', fontSize:'14px'}} className={classes.valor} colSpan={1}>Valor</th>
            </tr>
            </thead>
           
            <tbody style={{display:'flex', flexDirection:"column"}}>
           
            {historyData.slice(0, transactionNumbers || historyData.length).map((item, index) => (
      
      <tr style={{marginTop:'10px'}}  key={index}>
<td className="text-sm leading-5 font-circular-book" style={{  border:'none', textAlign: 'left', width:'70px', fontSize:'12px' }}>
{ item?.receiverAddress===item?.walletAddress && item?.type==='swap' ?  (
  <div className={classes.mdiRecurringPayment}>
               
  <svg style={{width:'20px', height:'20px'}} className={classes.icon5} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
<path
d='M3.75 7.5V22.5H16.65C16.3844 21.6933 16.2494 20.8493 16.25 20H8.75C8.75 19.337 8.48661 18.7011 8.01777 18.2322C7.54893 17.7634 6.91304 17.5 6.25 17.5V12.5C7.6375 12.5 8.75 11.3875 8.75 10H21.25C21.25 10.663 21.5134 11.2989 21.9822 11.7678C22.4511 12.2366 23.087 12.5 23.75 12.5V12.575C24.5875 12.575 25.425 12.725 26.25 13V7.5H3.75ZM15 11.25C12.875 11.2875 11.25 12.875 11.25 15C11.25 17.125 12.875 18.675 15 18.75C15.475 18.75 15.9625 18.65 16.425 18.4625C16.7625 17.0875 17.325 15.7875 18.7125 14.5125C18.5625 12.85 16.9875 11.2125 15 11.25ZM23.75 13.75L26.5625 16.5625L23.75 19.375V17.5C21.4375 17.5 19.925 19.95 20.95 22.025L19.5875 23.3875C17.3875 20.0625 19.7625 15.625 23.75 15.625V13.75ZM23.75 27.5L20.9375 24.6875L23.75 21.875V23.75C26.0625 23.75 27.575 21.3 26.55 19.225L27.9125 17.8625C30.1125 21.1875 27.7375 25.625 23.75 25.625V27.5Z'
fill='#00DC84'
/>
</svg>
</div>) :  item?.type=='payment' || item?.type=='onchain-out' || item?.type=='sell'  ? (  <div className={classes.uilMoneyWithdrawal}>
                
                <svg  style={{width:'20px', height:'20px'}} className={classes.icon4} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M27.5 2.5H2.5C2.16848 2.5 1.85054 2.6317 1.61612 2.86612C1.3817 3.10054 1.25 3.41848 1.25 3.75V13.75C1.25 14.0815 1.3817 14.3995 1.61612 14.6339C1.85054 14.8683 2.16848 15 2.5 15H6.25V26.25C6.25 26.5815 6.3817 26.8995 6.61612 27.1339C6.85054 27.3683 7.16848 27.5 7.5 27.5H22.5C22.8315 27.5 23.1495 27.3683 23.3839 27.1339C23.6183 26.8995 23.75 26.5815 23.75 26.25V15H27.5C27.8315 15 28.1495 14.8683 28.3839 14.6339C28.6183 14.3995 28.75 14.0815 28.75 13.75V3.75C28.75 3.41848 28.6183 3.10054 28.3839 2.86612C28.1495 2.6317 27.8315 2.5 27.5 2.5ZM8.75 25V22.5C9.41304 22.5 10.0489 22.7634 10.5178 23.2322C10.9866 23.7011 11.25 24.337 11.25 25H8.75ZM21.25 25H18.75C18.75 24.337 19.0134 23.7011 19.4822 23.2322C19.9511 22.7634 20.587 22.5 21.25 22.5V25ZM21.25 20C19.9239 20 18.6521 20.5268 17.7145 21.4645C16.7768 22.4021 16.25 23.6739 16.25 25H13.75C13.75 23.6739 13.2232 22.4021 12.2855 21.4645C11.3479 20.5268 10.0761 20 8.75 20V10H21.25V20ZM26.25 12.5H23.75V8.75C23.75 8.41848 23.6183 8.10054 23.3839 7.86612C23.1495 7.6317 22.8315 7.5 22.5 7.5H7.5C7.16848 7.5 6.85054 7.6317 6.61612 7.86612C6.3817 8.10054 6.25 8.41848 6.25 8.75V12.5H3.75V5H26.25V12.5ZM15 18.75C15.7417 18.75 16.4667 18.5301 17.0834 18.118C17.7001 17.706 18.1807 17.1203 18.4645 16.4351C18.7484 15.7498 18.8226 14.9958 18.6779 14.2684C18.5333 13.541 18.1761 12.8728 17.6517 12.3483C17.1272 11.8239 16.459 11.4667 15.7316 11.3221C15.0042 11.1774 14.2502 11.2516 13.5649 11.5355C12.8797 11.8193 12.294 12.2999 11.882 12.9166C11.4699 13.5333 11.25 14.2583 11.25 15C11.25 15.9946 11.6451 16.9484 12.3483 17.6517C13.0516 18.3549 14.0054 18.75 15 18.75ZM15 13.75C15.2472 13.75 15.4889 13.8233 15.6945 13.9607C15.9 14.098 16.0602 14.2932 16.1548 14.5216C16.2495 14.7501 16.2742 15.0014 16.226 15.2439C16.1778 15.4863 16.0587 15.7091 15.8839 15.8839C15.7091 16.0587 15.4863 16.1778 15.2439 16.226C15.0014 16.2742 14.7501 16.2495 14.5216 16.1548C14.2932 16.0602 14.098 15.9 13.9607 15.6945C13.8233 15.4889 13.75 15.2472 13.75 15C13.75 14.6685 13.8817 14.3505 14.1161 14.1161C14.3505 13.8817 14.6685 13.75 15 13.75Z'
      fill='#F27A7A'
    />
  </svg>
              </div>) :               <div className={classes.solarCardSendBroken}>
                <svg style={{width:'20px', height:'20px'}} className={classes.icon6} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M23.75 25V17.5M23.75 17.5L26.25 20M23.75 17.5L21.25 20'
      stroke='#00DC84'
      strokeWidth={1.875}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M27.5 15C27.5 10.2863 27.5 7.92875 26.035 6.465C24.5712 5 22.2137 5 17.5 5M17.5 25H12.5C7.78625 25 5.42875 25 3.965 23.535C2.5 22.0712 2.5 19.7137 2.5 15C2.5 10.2863 2.5 7.92875 3.965 6.465C5.42875 5 7.78625 5 12.5 5M12.5 20H7.5M16.25 20H15.625M2.5 12.5H8.75M27.5 12.5H13.75'
      stroke='#00DC84'
      strokeWidth={1.875}
      strokeLinecap='round'
    />
  </svg>
              </div>  }


</td>




<td className="text-sm leading-5 font-circular-book" style={{  textAlign: 'left', border:'none', width:'120px', fontSize:'12px' }}>
<div style={{color: '#08383f', fontWeight:900, fontSize:'12px'}}>{formatDate(item?.updatedAt)}</div>
</td>

<td className={` ${classes.textBlock21}`} style={{textAlign: 'left', width:'100px', fontSize:'12px', fontWeight:900, border:'none', color: getStatusColor(item?.status) }}>
{item?.type === 'swap' || item?.type==='payment' ? (
    <div style={{display:"flex"}}>
      <div className={classes._3528BRL475USDTBRL}>
        { item?.receiverAddress===item?.walletAddress && !item?.usdToBrla ?  (
          <>
           <div style={{display:'flex', flexDirection:"column"}}>
        <div className={classes.textBlock21}>+{(item?.usdAmount/100).toFixed(2)} USD</div>
        <div style={{color:"red"}} className={classes.textBlock21}>-{(item?.brlaAmount/100).toFixed(2)} BRL</div>
        </div>
        </>
        ) : item?.receiverAddress===item?.walletAddress && item?.usdToBrla ? (
        <>
        <div style={{display:'flex', flexDirection:"column"}}>
        <div  className={classes.textBlock21}>+{(item?.brlaAmount/100).toFixed(2)} BRL</div>
        <div style={{color:"red"}} className={classes.textBlock21}>-{(item?.usdAmount/100).toFixed(2)} USD</div>
        </div>
        
        </>
        )

        : item?.receiverAddress!==item?.walletAddress && !item?.usdToBrla ? (
          <>
          <div style={{color:'red'}}  className={classes.textBlock21}>-{(item?.brlaAmount/100).toFixed(2)} BRL</div>
          
          
          </>)
        
      : item?.type=='payment' ? (<div style={{color:"red"}} className={classes.textBlock21}>-{(item?.usdAmount/100).toFixed(2)} USD</div>)
        : (<div className={classes.textBlock21}>+{(item?.amount)} BRL</div>)
      }
       
      </div>
   
    </div>
  ) : item?.type==='payment' ?  (
    <div className={` ${classes.textBlock21}`} style={{display:'flex', textAlign: 'left', border:'none', marginLeft:'3px'}}>
      {formatAmount(item.amount)}
      
    </div>

    
  ) : item?.type==='onchain-deposit' && item?.coin!=='BRLA' ? (<div className={` ${classes.textBlock21}`} style={{display:'flex', textAlign: 'left', border:'none', marginLeft:'3px'}}>
  <div  className={classes.textBlock21}>+{(item?.amountclean)} USD</div> 
  
</div>)
: item?.type==='onchain-deposit' && item?.coin==='BRLA' ? (<div className={` ${classes.textBlock21}`} style={{display:'flex', textAlign: 'left', border:'none', marginLeft:'3px'}}>
<div className={classes.textBlock21}>+{(item?.amountclean)} BRL</div> 

</div>)
: item?.type==='onchain-out' && item?.coin!=='BRLA' ? (
  <div className={` ${classes.textBlock21}`} style={{display:'flex', textAlign: 'left', border:'none', marginLeft:'3px'}}>
  <div style={{ color:'red'}} className={classes.textBlock21}>-{(item?.amountclean)} USD</div> 

</div>
)
: item?.type==='onchain-out' && item?.coin==='BRLA' ? (
  <div className={` ${classes.textBlock21}`} style={{display:'flex', textAlign: 'left', border:'none', marginLeft:'3px'}}>
  <div style={{ color:'red'}} className={classes.textBlock21}>-{(item?.amountclean)} BRL</div> 
 
</div>
)
: (
    <div className={` ${classes.textBlock21}`} style={{display:'flex', textAlign: 'left', border:'none', marginLeft:'3px'}}>
      {formatAmount(item.amount)}
  
    </div>

    
  )}
</td>


       

</tr>
  ))}
            </tbody>
          
          
          </table>
        </div>
        : <div></div>}
{showDeposit && <DepositMobile  />}
{showTransfer && <TransferMobile onPixKeyTypeChange={handlePixKeyTypeChange} OnPixKeyValid={handlePixKeyValidChange} OnChangeRecebeToken={handleTokenRecebeChange} OnChangeToken={handleTokenSelectChange} />}
{showSwap && <SwapMobile OnChangeRecebeToken={handleTokenRecebeChange} OnChangeToken={handleTokenSelectChange} />}
{showPayment && <PaymentMobile onPixKeyTypeChange={handlePixKeyTypeChange} OnPixKeyValid={handlePixKeyValidChange} OnChangeRecebeToken={handleTokenRecebeChange} OnChangeToken={handleTokenSelectChange} />}

{showSettings &&   <div className={`${resets.storybrainResets} ${classes.root}`}>
      <div className={classes.link200}>
        <div className={classes.paraFazerAlteracoesNasSuasConf}>
          Para fazer alterações nas suas configurações de conta, por favor, acesse via web.
        </div>
      </div>
    </div>}

   


      </div>
      {showSecondMenu &&  
        
        <div ref={menuRef} style={{position:'absolute', zIndex:200000, bottom:'70px', left:'110px', transition: 'opacity 6s', opacity: showSecondMenu ? 1 : 0}} className={`${resets.storybrainResets} ${classes3.root}`}>
    <div className={classes3.menu_frame}>
      <div   onClick={(e) => {
        e.stopPropagation();
        clickTransfer();
        setShowsecondMenu(false);
        
      }} className={classes3.frame1}>
        <div className={classes3.solarCardSendBroken}>
          <svg className={classes3.icon} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M23.75 25V17.5M23.75 17.5L26.25 20M23.75 17.5L21.25 20'
      stroke='#00DC84'
      strokeWidth={1.875}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M27.5 15C27.5 10.2863 27.5 7.92875 26.035 6.465C24.5712 5 22.2137 5 17.5 5M17.5 25H12.5C7.78625 25 5.42875 25 3.965 23.535C2.5 22.0712 2.5 19.7137 2.5 15C2.5 10.2863 2.5 7.92875 3.965 6.465C5.42875 5 7.78625 5 12.5 5M12.5 20H7.5M16.25 20H15.625M2.5 12.5H8.75M27.5 12.5H13.75'
      stroke='#00DC84'
      strokeWidth={1.875}
      strokeLinecap='round'
    />
  </svg>
        </div>
        <div className={classes3.transferir}>Transferir</div>
      </div>
      <div onClick={(e) => {
        e.stopPropagation();
        clickSwap();
        setShowsecondMenu(false);
        
      }} className={classes3.frame2}>
        <div className={classes3.fontistoMoneySymbol}>
          <svg className={classes3.icon2} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_171_34)'>
      <path
        d='M14.9488 23.0175C14.8186 24.9533 13.9415 26.7629 12.5027 28.0644C11.0638 29.366 9.17563 30.0578 7.23648 29.9938C5.29734 29.9299 3.45886 29.1152 2.10888 27.7217C0.758903 26.3281 0.00299436 24.4647 0.000622486 22.5245C-0.00174939 20.5843 0.749601 18.7191 2.09617 17.3222C3.44273 15.9254 5.27922 15.1063 7.2182 15.0376C9.15718 14.9689 11.047 15.656 12.4891 16.9541C13.9311 18.2521 14.8126 20.0595 14.9475 21.995L14.9488 22.0188C15.0789 20.0829 15.956 18.2734 17.3948 16.9718C18.8337 15.6703 20.7219 14.9785 22.661 15.0424C24.6002 15.1064 26.4386 15.9211 27.7886 17.3146C29.1386 18.7081 29.8945 20.5715 29.8969 22.5117C29.8992 24.4519 29.1479 26.3172 27.8013 27.714C26.4548 29.1108 24.6183 29.93 22.6793 29.9987C20.7403 30.0674 18.8505 29.3802 17.4084 28.0822C15.9664 26.7842 15.0849 24.9767 14.95 23.0413L14.9488 23.0175ZM15.94 22.55C15.9401 23.4006 16.1077 24.2428 16.4333 25.0285C16.7588 25.8143 17.236 26.5283 17.8375 27.1297C18.439 27.731 19.153 28.208 19.9389 28.5335C20.7247 28.8589 21.5669 29.0263 22.4175 29.0263C23.2681 29.0262 24.1103 28.8586 24.896 28.533C25.6818 28.2074 26.3958 27.7303 26.9972 27.1288C27.5985 26.5273 28.0755 25.8132 28.401 25.0274C28.7264 24.2415 28.8938 23.3993 28.8937 22.5488C28.8936 20.831 28.211 19.1836 26.9963 17.9691C25.7815 16.7546 24.134 16.0723 22.4163 16.0725C20.6985 16.0727 19.0511 16.7552 17.8366 17.97C16.6221 19.1847 15.9398 20.8322 15.94 22.55ZM1.0075 22.5175V22.55C1.0075 23.8309 1.38733 25.083 2.09894 26.148C2.81056 27.213 3.82202 28.0431 5.0054 28.5333C6.18878 29.0234 7.49093 29.1517 8.7472 28.9018C10.0035 28.6519 11.1574 28.0351 12.0632 27.1294C12.9689 26.2237 13.5857 25.0697 13.8356 23.8135C14.0854 22.5572 13.9572 21.255 13.467 20.0716C12.9769 18.8883 12.1468 17.8768 11.0818 17.1652C10.0167 16.4536 8.76463 16.0738 7.48375 16.0738C5.7743 16.0799 4.1361 16.7593 2.92395 17.9646C1.71179 19.17 1.02327 20.8044 1.0075 22.5138V22.5175ZM5.23375 25C4.91201 24.5847 4.70549 24.0919 4.635 23.5713L4.63375 23.5563H3.93375V22.785H4.53375V22.2475H3.93375V21.4763H4.67125C4.7975 20.8888 5.06875 20.3775 5.445 19.9637L5.4425 19.9662C5.75876 19.6073 6.14786 19.3199 6.58389 19.1231C7.01992 18.9263 7.49287 18.8247 7.97125 18.825H7.995C8.60125 18.8288 9.17625 18.9513 9.70125 19.1725L9.67125 19.1613L9.37125 20.4363C8.98903 20.2378 8.56443 20.1348 8.13375 20.1363H8.1C7.56625 20.1363 7.0875 20.3675 6.75625 20.735L6.755 20.7363C6.59375 20.9338 6.4675 21.1675 6.39 21.4225L6.38625 21.4363H9.12625V22.2088H6.20625V22.7088H9.16V23.4813H6.375C6.42375 23.7813 6.55625 24.0438 6.745 24.2538L6.74375 24.2525C6.92971 24.4463 7.15531 24.5976 7.40512 24.6962C7.65493 24.7948 7.92308 24.8383 8.19125 24.8238H8.18625C8.63487 24.8209 9.07693 24.7158 9.47875 24.5163L9.46125 24.5238L9.69875 25.84C9.16148 26.1247 8.56303 26.2744 7.955 26.2763L7.8675 26.2775C7.36188 26.2777 6.86275 26.1637 6.40735 25.944C5.95195 25.7243 5.55205 25.4046 5.2375 25.0088L5.2325 25.0025L5.23375 25ZM19.9663 26.1075V25.235C20.63 24.9675 21.1037 24.3588 21.1737 23.6313V23.6238C21.1817 23.4737 21.1699 23.3232 21.1387 23.1763L21.1412 23.1875H20.0675V22.0475H20.94C20.8726 21.7679 20.8391 21.4813 20.84 21.1938V21.1388C20.84 20.8267 20.9056 20.5182 21.0326 20.2332C21.1596 19.9482 21.3451 19.6931 21.5771 19.4845C21.8091 19.2758 22.0824 19.1183 22.3792 19.0221C22.676 18.926 22.9897 18.8933 23.3 18.9262L23.29 18.925L23.3713 18.9237C23.805 18.9237 24.215 19.0225 24.5813 19.2L24.565 19.1925L24.3012 20.4338C24.0112 20.2799 23.6838 20.2106 23.3562 20.2338H23.3612C23.225 20.2188 23.0872 20.2347 22.9579 20.2803C22.8287 20.3259 22.7114 20.4 22.6147 20.4972C22.518 20.5943 22.4445 20.712 22.3995 20.8414C22.3546 20.9709 22.3393 21.1088 22.355 21.245V21.2413C22.355 21.5275 22.3925 21.805 22.46 22.07L22.455 22.0463H23.965V23.1863H22.62V23.2063C22.62 23.4738 22.5837 23.7325 22.515 23.9788L22.52 23.9588C22.4082 24.2554 22.2244 24.5196 21.985 24.7275L21.9825 24.73V24.7638H24.8687V26.1063L19.9663 26.1075ZM14.9488 7.985C14.8216 9.92073 13.9472 11.7313 12.5101 13.0344C11.073 14.3374 9.18575 15.031 7.24685 14.9686C5.30796 14.9062 3.46919 14.0928 2.11884 12.7C0.768492 11.3072 0.0122583 9.44422 0.00983041 7.50432C0.00740251 5.56442 0.758971 3.69951 2.10583 2.30338C3.45269 0.907252 5.28941 0.0891953 7.22814 0.0219558C9.16688 -0.0452837 11.0559 0.643557 12.4962 1.94302C13.9366 3.24248 14.8155 5.05085 14.9475 6.98625L14.9488 7.00875C15.0757 5.08093 15.9469 3.27789 17.3783 1.98034C18.8097 0.682778 20.6893 -0.00774599 22.6203 0.0545624C24.5513 0.116871 26.3825 0.927134 27.7273 2.31427C29.0721 3.70141 29.8252 5.55686 29.8276 7.48886C29.8301 9.42085 29.0816 11.2782 27.7403 12.6687C26.399 14.0592 24.5698 14.874 22.639 14.9412C20.7082 15.0083 18.8268 14.3225 17.3921 13.0286C15.9575 11.7346 15.0818 9.93375 14.95 8.00625L14.9488 7.985ZM15.94 7.485C15.9399 8.33556 16.1074 9.1778 16.4328 9.96364C16.7582 10.7495 17.2352 11.4635 17.8366 12.065C18.438 12.6665 19.1519 13.1437 19.9377 13.4692C20.7235 13.7948 21.5657 13.9624 22.4163 13.9625C23.2668 13.9626 24.109 13.7951 24.8949 13.4697C25.6807 13.1443 26.3948 12.6673 26.9963 12.0659C27.5978 11.4645 28.0749 10.7506 28.4005 9.9648C28.7261 9.17902 28.8937 8.33681 28.8937 7.48625C28.8941 5.76848 28.212 4.12093 26.9976 2.90604C26.3963 2.30449 25.6824 1.82727 24.8966 1.50163C24.1109 1.17598 23.2687 1.00829 22.4181 1.00813C20.7003 1.00779 19.0528 1.68986 17.8379 2.90427C16.623 4.11869 15.9403 5.76723 15.94 7.485ZM1.0075 7.485C1.00783 9.20261 1.69047 10.8497 2.90523 12.064C4.12 13.2783 5.76739 13.9603 7.485 13.96C9.20261 13.9597 10.8497 13.277 12.064 12.0623C13.2783 10.8475 13.9603 9.20011 13.96 7.4825C13.96 5.76511 13.2779 4.11804 12.0636 2.90354C10.8493 1.68904 9.20239 1.00658 7.485 1.00625C5.7691 1.01218 4.12515 1.69636 2.91171 2.90957C1.69826 4.12279 1.01376 5.7666 1.0075 7.4825V7.485ZM7.0475 11.885V10.47C6.5979 10.444 6.1649 10.291 5.79875 10.0287L5.80625 10.0338C5.57549 9.85162 5.38901 9.61955 5.26084 9.35498C5.13267 9.09041 5.06614 8.80023 5.06625 8.50625L5.06875 8.42V8.42375H6.17625C6.15396 8.68709 6.23004 8.94935 6.38979 9.15989C6.54954 9.37043 6.78163 9.51431 7.04125 9.56375L7.0475 9.565V7.82C6.90274 7.78213 6.75684 7.74878 6.61 7.72C6.2482 7.67353 5.9157 7.49692 5.67462 7.22318C5.43353 6.94943 5.30037 6.59727 5.3 6.2325V6.20125C5.3 5.66625 5.56375 5.19375 5.96875 4.905L5.97375 4.90125C6.28916 4.681 6.65503 4.54385 7.0375 4.5025L7.0475 4.50125V3.08875H7.92V4.5325C8.35375 4.56625 8.74625 4.725 9.06625 4.9725L9.06125 4.96875C9.47125 5.28 9.73375 5.76875 9.73375 6.3175L9.7325 6.38125V6.37875H8.625V6.3525C8.62512 6.14545 8.55733 5.94407 8.43202 5.77925C8.30671 5.61442 8.13079 5.49525 7.93125 5.44L7.925 5.43875V6.9825C8.19375 7.05 8.425 7.1175 8.73 7.1825C9.09375 7.2725 9.3975 7.4875 9.6 7.7775L9.60375 7.7825C9.81178 8.05056 9.91847 8.38346 9.905 8.7225C9.905 9.285 9.6125 9.77875 9.1725 10.06L9.16625 10.0637C8.79773 10.306 8.3706 10.4442 7.93 10.4638H7.925V11.8725L7.0475 11.885ZM7.91875 9.6C8.49 9.5325 8.75875 9.26375 8.75875 8.79375L8.76 8.74625C8.76002 8.61434 8.7178 8.48589 8.63952 8.37972C8.56124 8.27355 8.45102 8.19524 8.325 8.15625L8.32125 8.155C8.19745 8.0954 8.06693 8.05091 7.9325 8.0225L7.92125 8.02L7.91875 9.6ZM6.41 6.04C6.41 6.37625 6.61 6.61125 7.0475 6.71125V5.36875C6.61125 5.47 6.41 5.67125 6.41 6.04ZM21.5537 11.5V7.3725C21.0325 7.55625 20.5188 7.74625 20 7.93375V7.26875C20.52 7.07875 21.0412 6.89125 21.5537 6.695V6.3425C21.0362 6.51875 20.5175 6.71625 20 6.90125V6.23875C20.5175 6.045 21.0425 5.86 21.5537 5.66125V3.20875H22.3887V5.35625C23.2312 5.05125 24.0812 4.73 24.9312 4.42375V5.1125C24.0812 5.4175 23.2387 5.7275 22.3887 6.0325V6.3875C23.2375 6.08 24.0887 5.76 24.9312 5.455V6.14C24.0887 6.4525 23.2362 6.75625 22.3887 7.06375V10.6225C23.1826 10.5196 23.9119 10.1315 24.4407 9.53053C24.9695 8.92954 25.2615 8.15673 25.2625 7.35625H26.13V7.4875C26.1123 8.09564 25.9617 8.69253 25.6888 9.23625L25.7 9.2125C25.4671 9.67332 25.1529 10.0883 24.7725 10.4375L24.7688 10.44C24.3367 10.8372 23.8244 11.1369 23.2665 11.3189C22.7086 11.5009 22.1181 11.561 21.535 11.495L21.5537 11.4962V11.5Z'
        fill='#00DC84'
      />
    </g>
    <defs>
      <clipPath id='clip0_171_34'>
        <rect width={30} height={30} fill='white' />
      </clipPath>
    </defs>
  </svg>
        </div>
        <div className={classes3.converter}>Converter</div>
      </div>
      <div onClick={(e) => {
        e.stopPropagation();
        clickDeposit();
        setShowsecondMenu(false);
        
      }} className={classes3.frame3}>
        <div className={classes3.streamlineMoneyWalletMoneyPaym}>
          <svg className={classes3.icon3} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_171_36)'>
      <path
        d='M25.7143 16.0714V11.7857C25.7143 11.2174 25.4885 10.6724 25.0867 10.2705C24.6848 9.86862 24.1397 9.64286 23.5714 9.64286H3.21429C2.64597 9.64286 2.10092 9.86862 1.69906 10.2705C1.29719 10.6724 1.07143 11.2174 1.07143 11.7857V26.7857C1.07143 27.354 1.29719 27.8991 1.69906 28.3009C2.10092 28.7028 2.64597 28.9286 3.21429 28.9286H23.5714C24.1397 28.9286 24.6848 28.7028 25.0867 28.3009C25.4885 27.8991 25.7143 27.354 25.7143 26.7857V21.4286M8.22857 4.28571L20.3786 1.11429C20.5151 1.07582 20.658 1.06541 20.7987 1.0837C20.9393 1.10198 21.0748 1.14857 21.197 1.22067C21.3192 1.29276 21.4254 1.38886 21.5094 1.50316C21.5934 1.61746 21.6534 1.7476 21.6857 1.88571L22.2857 4.28571'
        stroke='#00DC84'
        strokeWidth={2.14286}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M27.8571 16.0714H22.5C21.9083 16.0714 21.4286 16.5511 21.4286 17.1429V20.3571C21.4286 20.9489 21.9083 21.4286 22.5 21.4286H27.8571C28.4489 21.4286 28.9286 20.9489 28.9286 20.3571V17.1429C28.9286 16.5511 28.4489 16.0714 27.8571 16.0714Z'
        stroke='#00DC84'
        strokeWidth={2.14286}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_171_36'>
        <rect width={30} height={30} fill='white' />
      </clipPath>
    </defs>
  </svg>
        </div>
        <div className={classes3.depositar}>Depositar</div>
      </div>
    </div>
  </div>
        
        }

      <div className={classes.menu_frame}>
        <div onClick={clickTransfer} className={classes.frame1}>
          <div className={classes.solarCardSendBroken3}>
            <svg className={classes.icon8} preserveAspectRatio='none' viewBox='0 0 31 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M24.25 25V17.5M24.25 17.5L26.75 20M24.25 17.5L21.75 20'
      stroke='#00DC84'
      strokeWidth={1.875}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M28 15C28 10.2863 28 7.92875 26.535 6.465C25.0712 5 22.7137 5 18 5M18 25H13C8.28625 25 5.92875 25 4.465 23.535C3 22.0712 3 19.7137 3 15C3 10.2863 3 7.92875 4.465 6.465C5.92875 5 8.28625 5 13 5M13 20H8M16.75 20H16.125M3 12.5H9.25M28 12.5H14.25'
      stroke='#00DC84'
      strokeWidth={1.875}
      strokeLinecap='round'
    />
  </svg>
          </div>
          <div  className={classes.transferir}>Transferir</div>
        </div>
        <div onClick={clickSwap} className={classes.frame2}>
          <div className={classes.fontistoMoneySymbol}>
            <svg className={classes.icon9} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_41_42)'>
      <path
        d='M14.9487 23.0175C14.8185 24.9533 13.9415 26.7629 12.5026 28.0644C11.0638 29.366 9.17562 30.0578 7.23648 29.9938C5.29734 29.9299 3.45886 29.1152 2.10888 27.7217C0.758902 26.3281 0.00299355 24.4647 0.000621672 22.5245C-0.0017502 20.5843 0.7496 18.7191 2.09617 17.3222C3.44273 15.9254 5.27922 15.1063 7.2182 15.0376C9.15718 14.9689 11.047 15.656 12.4891 16.9541C13.9311 18.2521 14.8126 20.0595 14.9475 21.995L14.9487 22.0188C15.0789 20.0829 15.956 18.2734 17.3948 16.9718C18.8337 15.6703 20.7219 14.9785 22.661 15.0424C24.6002 15.1064 26.4386 15.9211 27.7886 17.3146C29.1386 18.7081 29.8945 20.5715 29.8969 22.5117C29.8992 24.4519 29.1479 26.3172 27.8013 27.714C26.4548 29.1108 24.6183 29.93 22.6793 29.9987C20.7403 30.0674 18.8505 29.3802 17.4084 28.0822C15.9664 26.7842 15.0849 24.9767 14.95 23.0413L14.9487 23.0175ZM15.94 22.55C15.9401 23.4006 16.1077 24.2428 16.4333 25.0285C16.7588 25.8143 17.236 26.5283 17.8375 27.1297C18.439 27.731 19.153 28.208 19.9389 28.5335C20.7247 28.8589 21.5669 29.0263 22.4175 29.0263C23.2681 29.0262 24.1103 28.8586 24.896 28.533C25.6818 28.2074 26.3958 27.7303 26.9972 27.1288C27.5985 26.5273 28.0755 25.8132 28.401 25.0274C28.7264 24.2415 28.8938 23.3993 28.8937 22.5488C28.8936 20.831 28.211 19.1836 26.9963 17.9691C25.7815 16.7546 24.134 16.0723 22.4162 16.0725C20.6985 16.0727 19.0511 16.7552 17.8366 17.97C16.6221 19.1847 15.9398 20.8322 15.94 22.55ZM1.0075 22.5175V22.55C1.0075 23.8309 1.38732 25.083 2.09894 26.148C2.81056 27.213 3.82202 28.0431 5.0054 28.5333C6.18878 29.0234 7.49093 29.1517 8.7472 28.9018C10.0035 28.6519 11.1574 28.0351 12.0632 27.1294C12.9689 26.2237 13.5857 25.0697 13.8356 23.8135C14.0854 22.5572 13.9572 21.255 13.467 20.0716C12.9769 18.8883 12.1468 17.8768 11.0818 17.1652C10.0167 16.4536 8.76463 16.0738 7.48375 16.0738C5.7743 16.0799 4.1361 16.7593 2.92395 17.9646C1.71179 19.17 1.02327 20.8044 1.0075 22.5138V22.5175ZM5.23375 25C4.91201 24.5847 4.70549 24.0919 4.635 23.5713L4.63375 23.5563H3.93375V22.785H4.53375V22.2475H3.93375V21.4763H4.67125C4.7975 20.8888 5.06875 20.3775 5.445 19.9637L5.4425 19.9662C5.75876 19.6073 6.14785 19.3199 6.58389 19.1231C7.01992 18.9263 7.49287 18.8247 7.97125 18.825H7.995C8.60125 18.8288 9.17625 18.9513 9.70125 19.1725L9.67125 19.1613L9.37125 20.4363C8.98903 20.2378 8.56442 20.1348 8.13375 20.1363H8.1C7.56625 20.1363 7.0875 20.3675 6.75625 20.735L6.755 20.7363C6.59375 20.9338 6.4675 21.1675 6.39 21.4225L6.38625 21.4363H9.12625V22.2088H6.20625V22.7088H9.16V23.4813H6.375C6.42375 23.7813 6.55625 24.0438 6.745 24.2538L6.74375 24.2525C6.92971 24.4463 7.1553 24.5976 7.40512 24.6962C7.65493 24.7948 7.92308 24.8383 8.19125 24.8238H8.18625C8.63487 24.8209 9.07693 24.7158 9.47875 24.5163L9.46125 24.5238L9.69875 25.84C9.16148 26.1247 8.56303 26.2744 7.955 26.2763L7.8675 26.2775C7.36188 26.2777 6.86275 26.1637 6.40735 25.944C5.95195 25.7243 5.55205 25.4046 5.2375 25.0088L5.2325 25.0025L5.23375 25ZM19.9662 26.1075V25.235C20.63 24.9675 21.1037 24.3588 21.1737 23.6313V23.6238C21.1817 23.4737 21.1699 23.3232 21.1387 23.1763L21.1412 23.1875H20.0675V22.0475H20.94C20.8726 21.7679 20.8391 21.4813 20.84 21.1938V21.1388C20.84 20.8267 20.9056 20.5182 21.0326 20.2332C21.1596 19.9482 21.3451 19.6931 21.5771 19.4845C21.8091 19.2758 22.0824 19.1183 22.3792 19.0221C22.676 18.926 22.9897 18.8933 23.3 18.9262L23.29 18.925L23.3712 18.9237C23.805 18.9237 24.215 19.0225 24.5812 19.2L24.565 19.1925L24.3012 20.4338C24.0112 20.2799 23.6838 20.2106 23.3562 20.2338H23.3612C23.225 20.2188 23.0872 20.2347 22.9579 20.2803C22.8287 20.3259 22.7114 20.4 22.6147 20.4972C22.518 20.5943 22.4445 20.712 22.3995 20.8414C22.3546 20.9709 22.3393 21.1088 22.355 21.245V21.2413C22.355 21.5275 22.3925 21.805 22.46 22.07L22.455 22.0463H23.965V23.1863H22.62V23.2063C22.62 23.4738 22.5837 23.7325 22.515 23.9788L22.52 23.9588C22.4082 24.2554 22.2244 24.5196 21.985 24.7275L21.9825 24.73V24.7638H24.8687V26.1063L19.9662 26.1075ZM14.9487 7.985C14.8216 9.92073 13.9472 11.7313 12.5101 13.0344C11.073 14.3374 9.18575 15.031 7.24685 14.9686C5.30795 14.9062 3.46919 14.0928 2.11884 12.7C0.768491 11.3072 0.0122575 9.44422 0.0098296 7.50432C0.00740169 5.56442 0.75897 3.69951 2.10583 2.30338C3.45269 0.907252 5.28941 0.0891953 7.22814 0.0219558C9.16688 -0.0452837 11.0559 0.643557 12.4962 1.94302C13.9366 3.24248 14.8155 5.05085 14.9475 6.98625L14.9487 7.00875C15.0757 5.08093 15.9469 3.27789 17.3783 1.98034C18.8097 0.682778 20.6893 -0.00774599 22.6203 0.0545624C24.5513 0.116871 26.3825 0.927134 27.7273 2.31427C29.0721 3.70141 29.8252 5.55686 29.8276 7.48886C29.8301 9.42085 29.0816 11.2782 27.7403 12.6687C26.399 14.0592 24.5698 14.874 22.639 14.9412C20.7082 15.0083 18.8268 14.3225 17.3921 13.0286C15.9575 11.7346 15.0818 9.93375 14.95 8.00625L14.9487 7.985ZM15.94 7.485C15.9399 8.33556 16.1074 9.1778 16.4328 9.96364C16.7582 10.7495 17.2352 11.4635 17.8366 12.065C18.438 12.6665 19.1519 13.1437 19.9377 13.4692C20.7235 13.7948 21.5657 13.9624 22.4162 13.9625C23.2668 13.9626 24.109 13.7951 24.8949 13.4697C25.6807 13.1443 26.3948 12.6673 26.9963 12.0659C27.5978 11.4645 28.0749 10.7506 28.4005 9.9648C28.7261 9.17902 28.8937 8.33681 28.8937 7.48625C28.8941 5.76848 28.212 4.12093 26.9976 2.90604C26.3963 2.30449 25.6824 1.82727 24.8966 1.50163C24.1109 1.17598 23.2687 1.00829 22.4181 1.00813C20.7003 1.00779 19.0528 1.68986 17.8379 2.90427C16.623 4.11869 15.9403 5.76723 15.94 7.485ZM1.0075 7.485C1.00783 9.20261 1.69047 10.8497 2.90523 12.064C4.12 13.2783 5.76739 13.9603 7.485 13.96C9.20261 13.9597 10.8497 13.277 12.064 12.0623C13.2783 10.8475 13.9603 9.20011 13.96 7.4825C13.96 5.76511 13.2779 4.11804 12.0636 2.90354C10.8493 1.68904 9.20239 1.00658 7.485 1.00625C5.7691 1.01218 4.12515 1.69636 2.91171 2.90957C1.69826 4.12279 1.01376 5.7666 1.0075 7.4825V7.485ZM7.0475 11.885V10.47C6.5979 10.444 6.1649 10.291 5.79875 10.0287L5.80625 10.0338C5.57548 9.85162 5.38901 9.61955 5.26084 9.35498C5.13267 9.09041 5.06614 8.80023 5.06625 8.50625L5.06875 8.42V8.42375H6.17625C6.15396 8.68709 6.23004 8.94935 6.38979 9.15989C6.54954 9.37043 6.78163 9.51431 7.04125 9.56375L7.0475 9.565V7.82C6.90274 7.78213 6.75684 7.74878 6.61 7.72C6.2482 7.67353 5.9157 7.49692 5.67462 7.22318C5.43353 6.94943 5.30037 6.59727 5.3 6.2325V6.20125C5.3 5.66625 5.56375 5.19375 5.96875 4.905L5.97375 4.90125C6.28916 4.681 6.65503 4.54385 7.0375 4.5025L7.0475 4.50125V3.08875H7.92V4.5325C8.35375 4.56625 8.74625 4.725 9.06625 4.9725L9.06125 4.96875C9.47125 5.28 9.73375 5.76875 9.73375 6.3175L9.7325 6.38125V6.37875H8.625V6.3525C8.62512 6.14545 8.55733 5.94407 8.43202 5.77925C8.30671 5.61442 8.13079 5.49525 7.93125 5.44L7.925 5.43875V6.9825C8.19375 7.05 8.425 7.1175 8.73 7.1825C9.09375 7.2725 9.3975 7.4875 9.6 7.7775L9.60375 7.7825C9.81178 8.05056 9.91846 8.38346 9.905 8.7225C9.905 9.285 9.6125 9.77875 9.1725 10.06L9.16625 10.0637C8.79773 10.306 8.37059 10.4442 7.93 10.4638H7.925V11.8725L7.0475 11.885ZM7.91875 9.6C8.49 9.5325 8.75875 9.26375 8.75875 8.79375L8.76 8.74625C8.76002 8.61434 8.71779 8.48589 8.63952 8.37972C8.56124 8.27355 8.45102 8.19524 8.325 8.15625L8.32125 8.155C8.19745 8.0954 8.06693 8.05091 7.9325 8.0225L7.92125 8.02L7.91875 9.6ZM6.41 6.04C6.41 6.37625 6.61 6.61125 7.0475 6.71125V5.36875C6.61125 5.47 6.41 5.67125 6.41 6.04ZM21.5537 11.5V7.3725C21.0325 7.55625 20.5187 7.74625 20 7.93375V7.26875C20.52 7.07875 21.0412 6.89125 21.5537 6.695V6.3425C21.0362 6.51875 20.5175 6.71625 20 6.90125V6.23875C20.5175 6.045 21.0425 5.86 21.5537 5.66125V3.20875H22.3887V5.35625C23.2312 5.05125 24.0812 4.73 24.9312 4.42375V5.1125C24.0812 5.4175 23.2387 5.7275 22.3887 6.0325V6.3875C23.2375 6.08 24.0887 5.76 24.9312 5.455V6.14C24.0887 6.4525 23.2362 6.75625 22.3887 7.06375V10.6225C23.1826 10.5196 23.9119 10.1315 24.4407 9.53053C24.9695 8.92954 25.2615 8.15673 25.2625 7.35625H26.13V7.4875C26.1123 8.09564 25.9617 8.69253 25.6887 9.23625L25.7 9.2125C25.4671 9.67332 25.1529 10.0883 24.7725 10.4375L24.7687 10.44C24.3367 10.8372 23.8244 11.1369 23.2665 11.3189C22.7086 11.5009 22.1181 11.561 21.535 11.495L21.5537 11.4962V11.5Z'
        fill='#00DC84'
      />
    </g>
    <defs>
      <clipPath id='clip0_41_42'>
        <rect width={30} height={30} fill='white' />
      </clipPath>
    </defs>
  </svg>
          </div>
          <div  className={classes.converter}>Converter</div>

        </div>
        <div onClick={clickDeposit} className={classes.frame3}>
          <div className={classes.streamlineMoneyWalletMoneyPaym}>
           
            <svg className={classes.icon10} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg' >
    <g clipPath='url(#clip0_41_44)'>
      <path
        d='M25.7143 16.0714V11.7857C25.7143 11.2174 25.4885 10.6724 25.0867 10.2705C24.6848 9.86862 24.1397 9.64286 23.5714 9.64286H3.21429C2.64596 9.64286 2.10092 9.86862 1.69906 10.2705C1.29719 10.6724 1.07143 11.2174 1.07143 11.7857V26.7857C1.07143 27.354 1.29719 27.8991 1.69906 28.3009C2.10092 28.7028 2.64596 28.9286 3.21429 28.9286H23.5714C24.1397 28.9286 24.6848 28.7028 25.0867 28.3009C25.4885 27.8991 25.7143 27.354 25.7143 26.7857V21.4286M8.22857 4.28571L20.3786 1.11429C20.5151 1.07582 20.658 1.06541 20.7987 1.0837C20.9393 1.10198 21.0748 1.14857 21.197 1.22067C21.3192 1.29276 21.4254 1.38886 21.5094 1.50316C21.5934 1.61746 21.6534 1.7476 21.6857 1.88571L22.2857 4.28571'
        stroke='#00DC84'
        strokeWidth={2.14286}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M27.8571 16.0714H22.5C21.9083 16.0714 21.4286 16.5511 21.4286 17.1429V20.3571C21.4286 20.9489 21.9083 21.4286 22.5 21.4286H27.8571C28.4489 21.4286 28.9286 20.9489 28.9286 20.3571V17.1429C28.9286 16.5511 28.4489 16.0714 27.8571 16.0714Z'
        stroke='#00DC84'
        strokeWidth={2.14286}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_41_44'>
        <rect width={30} height={30} fill='white' />
      </clipPath>
    </defs>
  </svg>
          </div>
          <div  className={classes.depositar}>Depositar</div>
        </div>

        <div onClick={clickPayment} className={classes.frame3}>
          <div className={classes.streamlineMoneyWalletMoneyPaym}>
           
            <svg className={classes.icon10} preserveAspectRatio='none' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg' >
    <g clipPath='url(#clip0_41_44)'>
      <path
        d='M25.7143 16.0714V11.7857C25.7143 11.2174 25.4885 10.6724 25.0867 10.2705C24.6848 9.86862 24.1397 9.64286 23.5714 9.64286H3.21429C2.64596 9.64286 2.10092 9.86862 1.69906 10.2705C1.29719 10.6724 1.07143 11.2174 1.07143 11.7857V26.7857C1.07143 27.354 1.29719 27.8991 1.69906 28.3009C2.10092 28.7028 2.64596 28.9286 3.21429 28.9286H23.5714C24.1397 28.9286 24.6848 28.7028 25.0867 28.3009C25.4885 27.8991 25.7143 27.354 25.7143 26.7857V21.4286M8.22857 4.28571L20.3786 1.11429C20.5151 1.07582 20.658 1.06541 20.7987 1.0837C20.9393 1.10198 21.0748 1.14857 21.197 1.22067C21.3192 1.29276 21.4254 1.38886 21.5094 1.50316C21.5934 1.61746 21.6534 1.7476 21.6857 1.88571L22.2857 4.28571'
        stroke='#00DC84'
        strokeWidth={2.14286}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M27.8571 16.0714H22.5C21.9083 16.0714 21.4286 16.5511 21.4286 17.1429V20.3571C21.4286 20.9489 21.9083 21.4286 22.5 21.4286H27.8571C28.4489 21.4286 28.9286 20.9489 28.9286 20.3571V17.1429C28.9286 16.5511 28.4489 16.0714 27.8571 16.0714Z'
        stroke='#00DC84'
        strokeWidth={2.14286}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_41_44'>
        <rect width={30} height={30} fill='white' />
      </clipPath>
    </defs>
  </svg>
          </div>
          <div  className={classes.depositar}>Payment</div>
        </div>


      </div>
      <div style={{display:"flex", justifyContent:'center', alignItems:'center', alignContent:'center'}} className={classes.balance_frame}>
        
        <div style={{textAlign:'center'}}  className={classes.r40000}>
        <span style={{color:"#c8c8c8", fontSize:'14px', marginBottom:'5px'}} className={classes.r40000}>Saldo total</span>  
          <span>
          R$&nbsp;
          {
  isNaN(balance) 
    ? "Loading..." 
    : `${(Math.floor((parseFloat(balance)  + ((parseFloat(balanceUsd)) + (parseFloat(balanceUsdt) )) * usdSpot) * 100) / 100).toFixed(2)}`
}</span></div>
      </div>
      <div className={classes.welcome_frame}>
        <div className={classes.spanCbAvatar}>
          <div className={classes.bD}>{ users?.fullName?.charAt(0).toUpperCase()+users?.fullName?.charAt(1).toUpperCase()}</div>
        </div>
        <div className={classes.bemVindoBRLADigital}>Bem-vindo, {users?.fullName.split(' ')[0]}</div>
      </div>
      <div className={classes.bottom_Navigation}>
        <div className={classes.subtract}>
          <svg className={classes.icon11} preserveAspectRatio='none' viewBox='0 0 390 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M160 9.92308C160 4.44271 155.557 0 150.077 0H0V34C0 42.8366 7.16344 50 16 50H374C382.837 50 390 42.8366 390 34V0H239.923C234.443 0 230 4.44271 230 9.92308V9.92308C230 28.191 215.191 43 196.923 43H193.077C174.809 43 160 28.191 160 9.92308V9.92308Z'
      fill='url(#paint0_linear_41_48)'
    />
    <defs>
      <linearGradient id='paint0_linear_41_48' x1={0} y1={25} x2={390} y2={25} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#0A1B23' />
        <stop offset={1} stopColor='#08383F' />
      </linearGradient>
    </defs>
  </svg>
  
        </div>

        
     {showSecondMenu ? <div style={{background:'#FF6B6B'}} onClick={toggleMenu}
              ref={buttonRefMenu} className={`${classes.spanCbAvatar2} transitionEffect`}>
          <div style={{color:'black', fontSize:'20px'}} className={classes.unnamed}>X</div>
        </div>
 :      <div onClick={toggleMenu}
 ref={buttonRefMenu} className={`${classes.spanCbAvatar2} transitionEffect`}>
<div className={classes.unnamed}>+</div>
</div>
}
   
        
        
       
        <div onClick={clickHome} className={classes.sVG2}>
          <svg className={classes.icon12} preserveAspectRatio='none' viewBox='0 0 35 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7.51851 17.5H4.66667L17.5 4.66667L30.3333 17.5H27.4815M7.51851 17.5V27.4815C7.51851 28.2379 7.81898 28.9632 8.35381 29.498C8.88864 30.0329 9.61401 30.3333 10.3704 30.3333H24.6296C25.386 30.3333 26.1114 30.0329 26.6462 29.498C27.181 28.9632 27.4815 28.2379 27.4815 27.4815V17.5'
      stroke='#00DC84'
      strokeWidth={2.08333}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.2222 30.3333V21.7778C13.2222 21.0215 13.5227 20.296 14.0575 19.7612C14.5923 19.2264 15.3177 18.9259 16.0741 18.9259H18.9259C19.6823 18.9259 20.4077 19.2264 20.9425 19.7612C21.4773 20.296 21.7777 21.0215 21.7777 21.7778V30.3333'
      stroke='#00DC84'
      strokeWidth={2.08333}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
        </div>
        <div onClick={clickSettings} className={classes.sVG}>
          <svg className={classes.icon13} preserveAspectRatio='none' viewBox='0 0 35 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_41_52)'>
      <path
        d='M17.5 10.3985C16.5581 10.3837 15.6227 10.5565 14.7483 10.9067C13.8739 11.2569 13.0779 11.7775 12.4066 12.4383C11.7353 13.0992 11.2022 13.8869 10.8383 14.7558C10.4744 15.6246 10.287 16.5572 10.287 17.4992C10.287 18.441 10.4744 19.3737 10.8383 20.2425C11.2022 21.1113 11.7353 21.899 12.4066 22.5599C13.0779 23.2207 13.8739 23.7414 14.7483 24.0915C15.6227 24.4418 16.5581 24.6146 17.5 24.5997C19.3639 24.5705 21.1415 23.8096 22.4493 22.4811C23.7571 21.1526 24.49 19.3633 24.49 17.4992C24.49 15.635 23.7571 13.8456 22.4493 12.5172C21.1415 11.1887 19.3639 10.4278 17.5 10.3985ZM12.5842 17.4982C12.5719 16.8453 12.6899 16.1964 12.9312 15.5895C13.1726 14.9826 13.5325 14.4299 13.99 13.9637C14.4474 13.4976 14.9933 13.1273 15.5954 12.8745C16.1976 12.6217 16.8442 12.4915 17.4973 12.4915C18.1505 12.4915 18.7971 12.6217 19.3993 12.8745C20.0014 13.1273 20.5473 13.4976 21.0048 13.9637C21.4622 14.4299 21.8221 14.9826 22.0635 15.5895C22.3048 16.1964 22.4229 16.8453 22.4105 17.4982C22.3862 18.7852 21.8578 20.0112 20.9391 20.9128C20.0205 21.8144 18.7846 22.3195 17.4973 22.3195C16.2101 22.3195 14.9743 21.8144 14.0556 20.9128C13.1369 20.0112 12.6085 18.7852 12.5842 17.4982Z'
        fill='#00DC84'
      />
      <path
        d='M21.4286 2.93631C20.2753 -0.978438 14.7243 -0.978438 13.5711 2.93631L13.3646 3.63456C13.2841 3.90775 13.1435 4.15949 12.9531 4.37131C12.7627 4.58313 12.5274 4.74968 12.2643 4.85874C12.0012 4.9678 11.717 5.01662 11.4326 5.00162C11.1482 4.98663 10.8707 4.90819 10.6206 4.77206L9.98006 4.42207C6.39256 2.47082 2.4708 6.39607 4.42381 9.98007L4.7738 10.6188C4.91057 10.8692 4.98947 11.1471 5.0047 11.432C5.01993 11.7169 4.97111 12.0017 4.86182 12.2652C4.75253 12.5288 4.58555 12.7646 4.37317 12.9551C4.16079 13.1456 3.90839 13.2862 3.63455 13.3663L2.9363 13.5711C-0.978442 14.7243 -0.978442 20.2753 2.9363 21.4286L3.63455 21.6351C3.90781 21.7157 4.15955 21.8565 4.37137 22.0472C4.58319 22.2377 4.74972 22.4732 4.85876 22.7364C4.96781 22.9996 5.01662 23.2839 5.00162 23.5684C4.98661 23.8529 4.90818 24.1305 4.77205 24.3808L4.42206 25.0178C2.47081 28.6053 6.39256 32.5306 9.98006 30.5758L10.6188 30.2276C10.8691 30.0904 11.1469 30.0112 11.4318 29.9957C11.7167 29.9801 12.0015 30.0288 12.2651 30.138C12.5288 30.2471 12.7646 30.414 12.9552 30.6264C13.1457 30.8388 13.2862 31.0912 13.3663 31.3651L13.5711 32.0633C14.7243 35.9781 20.2753 35.9781 21.4286 32.0633L21.6351 31.3651C21.7157 31.0919 21.8565 30.8401 22.0472 30.6282C22.2377 30.4165 22.4732 30.2499 22.7364 30.1409C22.9996 30.0318 23.2839 29.9831 23.5684 29.998C23.8529 30.013 24.1305 30.0914 24.3808 30.2276L25.0178 30.5776C28.6053 32.5306 32.5306 28.6036 30.5758 25.0196L30.2276 24.3791C30.0911 24.129 30.0123 23.8514 29.9972 23.567C29.982 23.2824 30.0308 22.9981 30.14 22.7349C30.2491 22.4718 30.4157 22.2364 30.6278 22.046C30.8397 21.8557 31.0916 21.7152 31.3651 21.6351L32.0633 21.4286C35.9781 20.2753 35.9781 14.7243 32.0633 13.5711L31.3651 13.3646C31.0919 13.2841 30.8401 13.1435 30.6283 12.9531C30.4165 12.7627 30.25 12.5274 30.1409 12.2643C30.0318 12.0012 29.9831 11.717 29.998 11.4326C30.013 11.1482 30.0914 10.8707 30.2276 10.6206L30.5776 9.98007C32.5306 6.39257 28.6036 2.47081 25.0196 4.42382L24.3791 4.77381C24.1287 4.90992 23.8512 4.98829 23.5667 5.00317C23.2822 5.01806 22.998 4.96909 22.7348 4.85985C22.4717 4.75061 22.2364 4.58386 22.0461 4.37184C21.8558 4.15984 21.7154 3.90791 21.6351 3.63456L21.4286 2.93631ZM15.6693 3.55582C16.2066 1.72882 18.7931 1.72882 19.3303 3.55582L19.5368 4.25406C19.7093 4.84071 20.011 5.3813 20.4197 5.83613C20.8283 6.29095 21.3337 6.64846 21.8986 6.88244C22.4637 7.1164 23.0738 7.22088 23.6845 7.1882C24.295 7.15551 24.8906 6.98649 25.4273 6.69356L26.0643 6.34357C27.7356 5.43357 29.5643 7.26232 28.6543 8.93357L28.3061 9.57407C28.0135 10.1109 27.8448 10.7064 27.8124 11.3168C27.78 11.9274 27.8847 12.5373 28.1188 13.1021C28.353 13.6669 28.7106 14.172 29.1653 14.5805C29.6202 14.9891 30.1607 15.2905 30.7473 15.4628L31.4438 15.6693C33.2708 16.2066 33.2708 18.7931 31.4438 19.3303L30.7456 19.5368C30.1591 19.7095 29.6187 20.0114 29.1641 20.4201C28.7094 20.8289 28.3521 21.3342 28.1181 21.8991C27.8842 22.4639 27.7797 23.0739 27.8122 23.6845C27.8447 24.295 28.0135 24.8906 28.3061 25.4273L28.6561 26.0643C29.5661 27.7356 27.7373 29.5643 26.0661 28.6543L25.4273 28.3061C24.8903 28.0138 24.2947 27.8454 23.6842 27.8132C23.0737 27.781 22.4638 27.8856 21.899 28.1198C21.3342 28.3538 20.8289 28.7113 20.4202 29.1659C20.0114 29.6206 19.7096 30.1609 19.5368 30.7473L19.3303 31.4438C18.7931 33.2708 16.2066 33.2708 15.6693 31.4438L15.4628 30.7456C15.2897 30.1596 14.9878 29.6196 14.5791 29.1653C14.1704 28.711 13.6654 28.3539 13.1008 28.1201C12.5363 27.8862 11.9266 27.7816 11.3164 27.8138C10.7062 27.846 10.1109 28.0141 9.57406 28.3061L8.93531 28.6561C7.26406 29.5661 5.43531 27.7373 6.34531 26.0661L6.69355 25.4273C6.98649 24.8904 7.15551 24.2947 7.18818 23.6841C7.22087 23.0734 7.11641 22.4631 6.88246 21.8979C6.64851 21.3329 6.29101 20.8274 5.83618 20.4185C5.38137 20.0096 4.84077 19.7078 4.25405 19.5351L3.55581 19.3286C1.72881 18.7913 1.72881 16.2048 3.55581 15.6658L4.25405 15.4611C4.84028 15.2882 5.3804 14.9865 5.83485 14.5778C6.28931 14.1692 6.64658 13.6641 6.88049 13.0994C7.11439 12.5347 7.21901 11.925 7.18666 11.3147C7.15432 10.7044 6.98584 10.1091 6.69355 9.57231L6.34356 8.93357C5.43356 7.26232 7.26231 5.43357 8.93356 6.34357L9.57406 6.69182C10.1108 6.98409 10.7061 7.15257 11.3164 7.18491C11.9268 7.21726 12.5365 7.11265 13.1012 6.87874C13.6658 6.64484 14.171 6.28757 14.5796 5.8331C14.9882 5.37865 15.2901 4.83853 15.4628 4.25231L15.6693 3.55406V3.55582Z'
        fill='#00DC84'
      />
    </g>
    <defs>
      <clipPath id='clip0_41_52'>
        <rect width={35} height={35} fill='white' />
      </clipPath>
    </defs>
  </svg>
        </div>

        
        <div onClick={clicktransactions} className={classes.clarityTwoWayArrowsLine}>
          <svg className={classes.icon14} preserveAspectRatio='none' viewBox='0 0 35 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_41_55)'>
      <path
        d='M22.7792 16.3625C22.5974 16.1781 22.3498 16.0735 22.0909 16.0717C21.832 16.0699 21.583 16.171 21.3986 16.3528C21.2142 16.5346 21.1096 16.7821 21.1078 17.041C21.106 17.2999 21.2071 17.549 21.3889 17.7333L25.0055 21.3889H7.6125C7.35465 21.3889 7.10736 21.4913 6.92503 21.6736C6.7427 21.856 6.64027 22.1033 6.64027 22.3611C6.64027 22.619 6.7427 22.8663 6.92503 23.0486C7.10736 23.2309 7.35465 23.3333 7.6125 23.3333H25.0055L21.3889 26.9306C21.2989 27.0212 21.2276 27.1287 21.1791 27.2469C21.1307 27.3651 21.1059 27.4917 21.1064 27.6194C21.1068 27.7472 21.1325 27.8736 21.1818 27.9914C21.2311 28.1093 21.3031 28.2162 21.3937 28.3063C21.4844 28.3963 21.5919 28.4675 21.7101 28.516C21.8283 28.5645 21.9549 28.5892 22.0826 28.5887C22.2103 28.5883 22.3367 28.5627 22.4546 28.5134C22.5724 28.4641 22.6794 28.392 22.7694 28.3014L28.7097 22.3611L22.7792 16.3625Z'
        fill='#00DC84'
      />
      <path
        d='M12.8722 17.9375C13.0653 17.9386 13.2544 17.8822 13.4153 17.7755C13.5762 17.6687 13.7017 17.5165 13.7758 17.3381C13.8498 17.1598 13.8691 16.9634 13.8311 16.7741C13.7931 16.5847 13.6996 16.411 13.5625 16.275L9.95556 12.6389H27.3389C27.5967 12.6389 27.844 12.5365 28.0264 12.3541C28.2087 12.1718 28.3111 11.9245 28.3111 11.6667C28.3111 11.4088 28.2087 11.1615 28.0264 10.9792C27.844 10.7969 27.5967 10.6944 27.3389 10.6944H9.95556L13.5625 7.06806C13.6525 6.97741 13.7238 6.86992 13.7723 6.75172C13.8207 6.63353 13.8454 6.50695 13.845 6.3792C13.8445 6.25146 13.8189 6.12505 13.7696 6.0072C13.7203 5.88935 13.6483 5.78237 13.5576 5.69236C13.467 5.60235 13.3595 5.53108 13.2413 5.48261C13.1231 5.43414 12.9965 5.40942 12.8688 5.40988C12.6108 5.41079 12.3637 5.51415 12.1819 5.69722L6.24167 11.6667L12.1819 17.6361C12.2712 17.7297 12.3782 17.8046 12.4967 17.8564C12.6152 17.9081 12.7429 17.9357 12.8722 17.9375Z'
        fill='#00DC84'
      />
    </g>
    <defs>
      <clipPath id='clip0_41_55'>
        <rect width={35} height={35} fill='white' />
      </clipPath>
    </defs>
  </svg>
        </div>
      </div>
      <div className={classes.top_Iphone}>
        <div className={classes.notch}>
         
          <svg className={classes.icon15} preserveAspectRatio='none' viewBox='0 0 172 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M-7.62939e-06 0H172V0C168.686 0 166 2.68629 166 6V6.71329C166 9.20832 166 10.4558 165.902 11.5071C164.889 22.3234 156.323 30.8887 145.507 31.9016C144.456 32 143.208 32 140.713 32H31.2867C28.7917 32 27.5442 32 26.4929 31.9016C15.6766 30.8887 7.11128 22.3234 6.09843 11.5071C5.99999 10.4558 5.99999 9.20832 5.99999 6.71329V6C5.99999 2.68629 3.3137 0 -7.62939e-06 0V0Z'
      fill='black'
    />
  </svg>
        </div>
        
      
    
      </div>
    </div>
  );
};
export default WalletMobile;
